export const UPDATE_PEOPLE = 'people:updatePeople';

export function updatePeople(people){
	return {
		type:UPDATE_PEOPLE,
		payload:{
			people:people
		}
	}
}